import type { TableCellData, TableData } from 'ricos-schema';
import { Node_Type } from 'ricos-schema';

import type { NodeBuilder } from './types';
import { isDefined } from './utils';

export const table = (...args: (NodeBuilder | TableData)[]): NodeBuilder => {
  const tableData = args.find((a): a is TableData => !('type' in a));

  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: Node_Type.TABLE,
      nodes: args
        .map(arg => ('type' in arg && arg.type === 'block_node' ? arg.node(getId) : undefined))
        .filter(isDefined),
      tableData: tableData
        ? tableData
        : {
            // these values are from normalized 1x1 table
            dimensions: { rowsHeight: [47], colsWidthRatio: [0], colsMinWidth: [0] },
          },
    }),
  };
};

export const tableRow = (...args: NodeBuilder[]): NodeBuilder => {
  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: Node_Type.TABLE_ROW,
      nodes: args.map(arg => arg.node(getId)),
    }),
  };
};

export const tableCell = (...args: (NodeBuilder | TableCellData)[]): NodeBuilder => {
  const tableCellData = args.find((a): a is TableCellData => !('type' in a)) ?? {};
  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: Node_Type.TABLE_CELL,
      nodes: args
        .map(arg => ('type' in arg && arg.type === 'block_node' ? arg.node(getId) : undefined))
        .filter(isDefined),
      tableCellData,
    }),
  };
};
